{
  "version": 1,
  "asset_id": "006de53e-5e3a-46db-bf82-bb66569f63fd",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/006de53e-5e3a-46db-bf82-bb66569f63fd/sleeve-to-bypass-dissection.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/006de53e-5e3a-46db-bf82-bb66569f63fd/sleeve-to-bypass-dissection.png",
  "original_filename": "sleeve-to-bypass-dissection.png",
  "size": 689410,
  "content_type": "image/png",
  "created_at": "2026-10-05T18:59:24Z"
}
